import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  roles: [], // Initial roles array
};

const roleSlice = createSlice({
  name: 'role',
  initialState,
  reducers: {
    setRoles: (state, action) => {
      state.roles = action.payload;
      state.isDefaultSet = action.payload.some((role) => role.isDefault);
    },
    addRole: (state, action) => {
      state.roles.push(action.payload);
    },
    updateRole: (state, action) => {

      const updatedRole = action.payload;

      const prevRole = state.roles.find(role => role.id === updatedRole.id );

      let updatedPrevRoles = state.roles;

      if ( ! prevRole.isDefault && updateRole.isDefault ) {
        // Set isDefault to false for previous default roles
        updatedPrevRoles = state.roles.map((prevRole) =>
          prevRole.isDefault
            ? { ...prevRole, isDefault: false }
            : prevRole
        );

        state.isDefaultSet = true;
      }

      state.roles = updatedPrevRoles.map((prevRole) =>
        prevRole.id === updatedRole.id ? updatedRole : prevRole
      );

    },
    deleteRole: (state, action) => {
      state.roles.filter((role) => role.id !== action.payload);
    },
    setIsDefaultSet: (state, action) => {
      state.isDefaultSet = action.payload;
    },
  },
});

export const { setRoles, addRole, updateRole, deleteRole, setIsDefaultSet, } = roleSlice.actions;

export default roleSlice.reducer;
